import { BTSessionStatus } from '../../../../constants';
import StatusIconRenderer from '../../StatusIconRenderer';
import { ServiceCodes } from '../../billings/claims/constants';

export const sessionHistoryColumns = [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: BTSessionStatus) => {
        return (
          <StatusIconRenderer
            procedureCode={ServiceCodes.SessionProcedureCode}
            status={value}
            isAwaitingFinalization={value === BTSessionStatus.AwaitingFinalization}
          />
        );
      },
    },
  },
  {
    name: 'client',
    label: 'Client',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'session_id',
    label: 'ID',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'date',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'time',
    label: 'Time',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'duration',
    label: 'Duration',
    options: {
      filter: false,
      sort: false,
    },
  },
];
